import {Component, OnInit} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {Supplier} from '../../../Models/Supplier';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {SupplierService} from '../../../Services/supplier.service';
import {LanguageService} from '../../../../translation/Services/language.service';

@Component({
  selector: 'app-manage-supplier',
  templateUrl: './manage-supplier.component.html',
  styleUrls: ['./manage-supplier.component.scss']
})
export class ManageSupplierComponent implements OnInit {

  public classicBox;
  public lastValue = {supplier: new Supplier()};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public isEdit = false;
  public supplierId: number;
  // public countries = [];
  options: FormlyFormOptions = {};
  public languages = [];

  public deliveryWeekOptions = [];
  constructor(
    public helper: Helper,
    private route: ActivatedRoute,
    // public countryService: CountryService,
    private translate: TranslateService,
    private supplierService: SupplierService,
    private router: Router,
    public languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    for (let week = 1; week <= 99; week++) {
      this.deliveryWeekOptions.push({
        label: week + ' ' + this.translate.instant('global.week'),
        value: week
      });
    }
    this.route.params.subscribe(params => {
      new Promise((resolve, reject) => {
        if (Helper.isDefined(params['id'])) {
          this.supplierId = params['id'];
          this.isEdit = true;

          this.supplierService.getSupplierItem(this.supplierId).subscribe(resp => {
            resolve(resp);
          });
        } else {
          resolve(new Supplier());
        }
      }).then((supplier: any) => {
        if (supplier.language) {
          supplier.language = supplier.language.id || null;
        }
        this.lastValue = {supplier: (<Supplier>supplier)};

        // if(Helper.isDefined(this.lastValue.supplier.country) && this.lastValue.supplier.country){
        //   this.lastValue.supplier.country = this.lastValue.supplier.country.id;
        // }
      }).then(() => {
        this.languageService.list().subscribe(response => {
          this.languages = response.languages.map((value) => ({
              label: value.name,
              value: value.id
            }));
          this.classicBox = <FormlyFieldConfig>[
            {
              className: 'section-label',
              template: '<div><strong>' + (this.isEdit) ? this.lastValue.supplier.companyName : this.translate.instant('admin.supplier.show.add.supplier') + '</strong></div>',
            },
          ];
          this.classicBox = <FormlyFieldConfig>[
            {
              fieldGroupClassName: 'row',
              key: 'supplier',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'companyName',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.companyName'),
                    required: true,
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.supplier.show.address_information') + '</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'supplier',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'address',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.address'),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'zipCode',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.zipCode'),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'city',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.city'),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  key: 'countryName',
                  type: 'input',
                  className: 'col-3 ',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.country'),
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.supplier.show.contact_information') + '</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'supplier',
              fieldGroup: [
                {
                  className: 'col-3 ',
                  type: 'input',
                  key: 'email',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.email'),
                    required: true,
                    maxLength: environment.maxStringLength,
                    pattern: environment.emailPattern,
                  },
                  validation: {
                    messages: {
                      pattern: this.translate.instant('errors.invalid'),
                      required: this.translate.instant('errors.required'),
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                    },
                  },
                },
                {
                  className: 'col-3',
                  type: 'input',
                  key: 'phone',
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.phone'),
                    pattern: '[0-9]+',
                    maxLength: environment.maxStringLength,
                  },
                  validation: {
                    messages: {
                      maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                      pattern: this.translate.instant('errors.invalid'),
                    },
                  },
                },
              ],
            },
            {
              className: 'section-label',
              template: '<div><strong>' + this.translate.instant('admin.supplier.show.other_information') + '</strong></div><hr />',
            },
            {
              fieldGroupClassName: 'row',
              key: 'supplier',
              fieldGroup: [
                {
                  key: 'language',
                  type: 'ng-select',
                  className: 'col-3 ',
                  templateOptions: {
                    label: this.translate.instant('doctrine.attributes.language'),
                    options: this.languages,
                    required: true,
                  },
                },
                {
                  key: 'status',
                  type: 'ng-select',
                  className: 'col-3 ',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.status'),
                    required: true,
                    options: [
                      {label: this.translate.instant('global.active'), value: true},
                      {label: this.translate.instant('global.inactive'), value: false},
                    ],
                  },
                },
                {
                  key: 'deliveryWeek',
                  type: 'ng-select',
                  className: 'col-3 ',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.backoffice.order.delivery_week'),
                    required: true,
                    options: this.deliveryWeekOptions,
                  },
                },
                {
                  key: 'hasCancellationEmail',
                  type: 'checkbox',
                  className: 'col-3 pt-4',
                  defaultValue: true,
                  templateOptions: {
                    label: this.translate.instant('doctrine.supplier.hasCancellationEmail'),
                    required: false,
                  },
                }
              ],
            },
          ];
        });
      });
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }


  submitItem(next: boolean) {
    if (next) {
      const supplier = JSON.parse(JSON.stringify(this.lastValue));

      delete supplier.supplier.id;
      delete supplier.supplier.number;
      delete supplier.supplier.models;
      this.supplierService.manageSupplier(supplier, this.isEdit, this.supplierId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/supplier/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/supplier/overview');
    }
  }

}
